import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import VoiceInput from "./pages/Reminder";
import MyDays from "./pages/MyDays";
import Login from "./pages/Login";
import NoPermission from "./pages/NoPermission";
import AccountExpired from "./pages/AccountExpired";
import NotFound from "./components/NotFound";
import Footer from "./components/Footer";
import PassChange from "./pages/PassChange";
import Groups from "./pages/Groups";
import AddGroup from "./pages/AddGroup";
import AddGroupOwnerEmail from "./pages/AddGroupOwnerEmail";
import VN from "./components/VN";
import AddPhoto from "./pages/AddPhoto";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import AddUser from "./pages/AddUser";
import AddUserWeight from "./pages/AddUserWeight";
import AddGroupOwner from "./pages/AddGroupOwner";
import EditUser from "./pages/EditUser";
import EditUserTabs from "./pages/EditUserTabs";
import ReminderTabs from "./pages/ReminderTabs";
import { UserProvider } from "./components/UserContext";
import { UserDataProvider } from "./components/UserDataContext";
import { SearchProvider } from "./components/SearchContext";
import AddBowDose from "./pages/AddBowDose";
import Timer from "./pages/Timer";
//import UseStore from "./components/store";
import passresetmail from "./pages/PassResetMail";
import PassResetMail from "./pages/PassResetMail";

export const API_URL = "https://mojapamiec.pl/api";
export const APP_NAME = "Moja pamięć";
export const windowWidth = 768;
export const marginBottom = "2%";

function App() {
  const baseUrl = process.env.REACT_APP_BASE_URL || "/";

  return (
    <UserDataProvider>
      <UserProvider>
        <SearchProvider>
          <BrowserRouter basename={baseUrl}>
            <Routes>
              <Route path="/" element={<Navigate to="/login" />} />
              <Route path="/login" element={<Login />} />
              <Route path="/add" element={<AddUser />} />
              <Route path="/addweight" element={<AddUserWeight />} />
              <Route path="/edit/:id" element={<EditUser />} />
              <Route path="/edittabs/:id" element={<EditUserTabs />} />
              <Route path="/passchange" element={<PassChange />} />
              <Route path="/reminder" element={<VoiceInput />} />
              <Route path="/remindertabs/:id" element={<ReminderTabs />} />
              <Route path="/mydays" element={<MyDays />} />
              <Route path="/nopermission" element={<NoPermission />} />
              <Route path="/expired" element={<AccountExpired />} />
              <Route path="/vn" element={<VN />} />
              <Route path="/groups" element={<Groups />} />
              <Route path="/addgroup" element={<AddGroup />} />
              <Route path="/addgroupowner" element={<AddGroupOwner />} />
              <Route path="/addbowdose" element={<AddBowDose />} />

              <Route path="/passresetmail" element={<PassResetMail />} />
              <Route path="/footer" element={<Footer />} />
              <Route path="/timer" element={<Timer />} />
              <Route
                path="/addgroupowneremail"
                element={<AddGroupOwnerEmail />}
              />
              <Route path="/addphoto" element={<AddPhoto />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </SearchProvider>
      </UserProvider>
    </UserDataProvider>
  );
}

export default App;
